import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, from, map } from 'rxjs';
import { SupabaseService } from '../services/supabase.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.supabaseService.getCurrentUser()).pipe(
      map((user) => {
        if (user) {
          return true;
        } else {
          // Preserve where the user was headed so login can send them back.
          this.router.navigate(['auth/login'], {
            queryParams: { returnUrl: state.url },
          });

          return false;
        }
      })
    );
  }
}
